var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-chip',_vm._b({attrs:{"label":"","color":"green","x-small":""}},'v-chip',{ ..._vm.$props },false),[_vm._v(" "+_vm._s(_vm.value ? _vm.value.roles[0].name : "SEM PERFIL")+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }